import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';

const Blog = () => {
  const [email, setEmail] = useState('');
  const [website, setWebsite] = useState(''); // Honeypot field
  const [isSubscribing, setIsSubscribing] = useState(false);
  const [subscriptionMessage, setSubscriptionMessage] = useState('');
  const [formLoadTime, setFormLoadTime] = useState(Date.now());

  // Set form load time on component mount (anti-spam)
  useEffect(() => {
    setFormLoadTime(Date.now());
  }, []);

  // Función para manejar la suscripción
  const handleSubscription = async (e) => {
    e.preventDefault();
    
    // Clear previous messages
    setSubscriptionMessage('');
    
    if (!email) {
      setSubscriptionMessage('Por favor ingresa tu email');
      return;
    }

    if (!email.includes('@')) {
      setSubscriptionMessage('Por favor ingresa un email válido');
      return;
    }

    // Calculate time to fill (for anti-spam)
    const timeToFill = Date.now() - formLoadTime;

    setIsSubscribing(true);
    
    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
      
      const response = await fetch(`${backendUrl}/api/newsletter/subscribe`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email,
          website: website,  // Honeypot field
          time_to_fill: timeToFill,
          source: 'Blog'  // Identificar origen
        }),
      });
      
      const data = await response.json();
      
      if (response.ok) {
        setSubscriptionMessage(data.message || '¡Gracias por suscribirte! Te notificaremos cuando lancemos el blog.');
        setEmail('');
        setWebsite('');
        setFormLoadTime(Date.now());
        
        // Clear success message after 5 seconds
        setTimeout(() => {
          setSubscriptionMessage('');
        }, 5000);
      } else {
        setSubscriptionMessage(data.detail || 'Error al suscribirte. Por favor, intenta nuevamente.');
      }
      
    } catch (error) {
      console.error('Error subscribing:', error);
      setSubscriptionMessage('Error de conexión. Por favor, intenta nuevamente.');
    } finally {
      setIsSubscribing(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      
      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        {/* Background Image */}
        <img 
          src="https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Mulata.jpg"
          alt="Interior de ADASTRA"
          className="absolute inset-0 w-full h-full object-cover"
        />
        
        {/* Overlay */}
        <div className="absolute inset-0 bg-black/50" />
        
        {/* Content */}
        <div className="relative z-10 text-center text-white px-6">
          <div className="text-center">
            <h2 className="font-sans text-5xl md:text-6xl font-light text-white leading-tight mb-6">
              <span className="text-green-400 font-normal italic">Próximamente</span>
            </h2>
            <p className="font-sans text-xl text-gray-200 max-w-2xl mx-auto leading-relaxed mb-8">
              Estamos preparando contenido exclusivo para compartir contigo. Historias, recetas y la cultura gastronómica de ADASTRA - suscríbete para recibir actualizaciones.
            </p>
            
            {/* Subscription Form */}
            <div className="max-w-lg mx-auto">
              <form onSubmit={handleSubscription} className="flex flex-col md:flex-row gap-3">
                <div className="flex-1">
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Tu email"
                    className="w-full bg-white/10 backdrop-blur-sm border border-white/30 rounded-lg px-4 py-3 text-white placeholder-gray-300 focus:outline-none focus:border-green-400 focus:ring-1 focus:ring-green-400 transition-colors"
                    disabled={isSubscribing}
                  />
                </div>
                
                {/* Honeypot field - hidden from users, only bots will fill it */}
                <div style={{ position: 'absolute', left: '-9999px', width: '1px', height: '1px', overflow: 'hidden' }}>
                  <label htmlFor="website-blog">Website (do not fill)</label>
                  <input
                    type="text"
                    id="website-blog"
                    name="website"
                    value={website}
                    onChange={(e) => setWebsite(e.target.value)}
                    tabIndex="-1"
                    autoComplete="off"
                    aria-hidden="true"
                  />
                </div>
                
                <button
                  type="submit"
                  disabled={isSubscribing}
                  className="bg-green-600 text-white font-semibold py-3 px-6 rounded-lg hover:bg-green-700 transition-colors flex items-center justify-center space-x-2 disabled:opacity-70 disabled:cursor-not-allowed shadow-lg whitespace-nowrap w-full md:w-auto"
                >
                  {isSubscribing ? (
                    <>
                      <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent"></div>
                      <span>Suscribiendo...</span>
                    </>
                  ) : (
                    <>
                      <FontAwesomeIcon icon={faPaperPlane} />
                      <span>SUSCRIBIRME</span>
                    </>
                  )}
                </button>
              </form>
              
              {subscriptionMessage && (
                <p className={`mt-4 text-sm text-center ${subscriptionMessage.includes('Gracias') ? 'text-green-400' : 'text-red-400'}`}>
                  {subscriptionMessage}
                </p>
              )}
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Blog;